<template>
  <!-- <HelloWorld /> -->
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mb-4>
        <h1 class="main-title">DHTML</h1>
        <p class="subheading font-weight-regular font-zcool">
          HTML Dinámico
        </p>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
  data () {
      return {
         
      }
  },
  components: {
    
  }
  }
</script>